/**
 * Created on 2018/4/16.
 */
let language = [
    {
        value: 'zh_CN',
        label: 'zh_CN'
    },
    {
        value: 'en_US',
        label: 'en_US'
    },
    {
        value: 'ru_RU',
        label: 'ru_RU'
    },
    {
        value: 'fr_FR',
        label: 'fr_FR'
    },
    {
        value: 'es_ES',
        label: 'es_ES'
    },
    {
        value: 'de_DE',
        label: 'de_DE'
    },
    {
        value: 'nl_NL',
        label: 'nl_NL'
    },
    {
        value: 'cs_CZ',
        label: 'cs_CZ'
    },
    {
        value: 'pl_PL',
        label: 'pl_PL'
    },
    {
        value: 'iw_IL',
        label: 'iw_IL'
    },
    {
        value: 'hu_HU',
        label: 'hu_HU'
    },
    {
        value: 'ja_JP',
        label: 'ja_JP'
    },
    {
        value: 'kr_KR',
        label: 'kr_KR'
    },
    {
        value: 'vn_VN',
        label: 'vn_VN'
    },
    {
        value: 'zh_TW',
        label: 'zh_TW'
    }
]
export default language
